module.exports = __webpack_public_path__ + "static/media/disaster.612b73e1.JPG";